import { Icon } from "@mui/material";
import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import MinimalSelect from "../../components/MinimalSelect";
import theme from "../../styles/theme";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { VersionContext } from "../../context/VersionContext";

const Card = styled("div")`
  background-color: #ffffff;
  color: gray;
  padding: 30px;
  border-radius: 5px;
  width: 500px;
  text-align: left;
  margin-top: 20px;
  box-shadow: 0px 2px 20px #a8a8a83d;
`;

const AlignCenter = styled("div")`
  text-align: center;
`;

const Title = styled("div")`
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #2633d4;
`;

export const UniversityPage = () => {
  const [universityOption, setUniversityOption] = useState([]);
  const [selectedUni, setSelectedUni] = useState<string>("");
  const [selectedProgId, setSelectedProgId] = useState<string>("");
  const [selectedProgram, setSelectedProgram] = useState<string>("");
  const [programOptions, setProgramOptions] = useState<any[]>([]);

  const navigate = useNavigate();
  const versionContext = useContext(VersionContext);
  // useEffect(() => {
  //   fetchUniversities();
  //   localStorage.removeItem('selectedVersion')
  //   localStorage.removeItem('active_version')
  //   localStorage.removeItem('allVersions')
  //   localStorage.removeItem('university')
  //   versionContext.setCurrentVersion(EmptyVersion);
  // }, []);

  useEffect(() => {
    axios
      .get("/university")
      .then((res) => {
        const list = res.data.universities.map((v: any) => ({
          label: v.name,
          value: v.short_name,
        }));
        setUniversityOption(list);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!selectedUni) return;

    axios
      .get(`/university?university_code=${selectedUni}`)
      .then((res) => {
        const list = res.data.universities[0].program.map((p: any) => ({
          label: p.short_name,
          value: p.short_name,
          id: p.id,
        }));
        setProgramOptions(list);
      })
      .catch(() => {});
  }, [selectedUni]);

  const handleSelect = () => {
    localStorage.setItem("selectedProgram", selectedProgram);
    localStorage.setItem("selectedProgId", selectedProgId);
    localStorage.setItem("university", selectedUni);
    localStorage.removeItem("selectedVersion");

    // fetchParent(selectedUni, selectedProgram);
    // onSelect(selectedProgram);
    // setOpen(false);
    window.location.pathname = "/curriculum/version";
  };

  // const fetchUniversities = () => {
  //   axios
  //     .get("/university")
  //     .then((res) => {
  //       console.log(res);
  //       const array: any = [];
  //       const raw = res.data.universities.forEach((v: any) =>
  //         array.push({ label: v.name, value: v.short_name })
  //       );
  //       setUniversityOption(array);
  //     })
  //     .catch(function (error) {});
  // };

  const onStart = () => {
    localStorage.setItem("university", selectedUni);
    navigate("/curriculum/version");
  };
  return (
    <FlexBox justify="center" style={{ paddingTop: 70 }}>
      <AlignCenter>
        <FlexGrow>
          {/* <h2 style={{ color: theme.color.darkBlueGray500}}>SIMON</h2> */}
          <img src="/assets/Simon-Logo-Blue.png" width={300} />
        </FlexGrow>
        <Card>
          <Title>
            <Icon>account_balance</Icon>
            Select University & Program
          </Title>

          <div style={{ paddingTop: 20, fontSize: 14, color: "#575757" }}>
            University:
          </div>
          <MinimalSelect
            isClearable={false}
            onChange={(item: any) => {
              setSelectedUni(item.value);
              setSelectedProgram("");
            }}
            name="university"
            options={universityOption}
            styles={{
              container: (base) => ({ ...base, minWidth: "100%" }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            value={universityOption.find((u: any) => u.value === selectedUni)}
          />

          <div style={{ paddingTop: 10, fontSize: 14, color: "#575757" }}>
            Program:
          </div>

          <MinimalSelect
            isClearable={false}
            onChange={(item: any) => {
              setSelectedProgram(item.value);
              setSelectedProgId(item.id);
            }}
            name="program"
            options={programOptions}
            isDisabled={!selectedUni}
            styles={{
              container: (base) => ({ ...base, minWidth: "100%" }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            value={programOptions.find((p: any) => p.value === selectedProgram)}
          />

          <FlexBox justify="end" style={{ paddingTop: 30 }}>
            {localStorage.getItem("selectedProgram") &&
              localStorage.getItem("selectedProgId") && (
                <Button
                  className="reduce_opct_onhover"
                  onClick={() => {
                    navigate("/curriculum/version");
                  }}
                  style={{
                    border: "2px solid #64748B",
                    padding: "8px 40px",
                    fontSize: "14px",
                  }}
                >
                  Cancel
                </Button>
              )}
            <Button
              className="reduce_opct_onhover"
              onClick={handleSelect}
              disabled={!selectedProgram}
              style={{
                width: 120,
                whiteSpace: "nowrap",
                background: theme.color.blueButton,
                color: "white",
                boxShadow: "0 2px 5px #808080cc",
                border: "none",
                gap: 10,
              }}
            >
              Start
              <Icon fontSize="small">start</Icon>
            </Button>
          </FlexBox>
        </Card>
      </AlignCenter>
    </FlexBox>
  );
};
